import { useTranslation } from "../../i18n";
import { ProductImage } from "../picking-shared/PickingScreen";
import { groupBarcode } from "../picking-shared/barcodeFormat";
import "./put-away-shared.css";

export interface LastPutAwayItem {
    title: string | null;
    barcode: string;
    sku: string;
    thumbnailUrl: string | null;
    imageUrl: string | null;
}

interface Props {
    item: LastPutAwayItem | null;
}

const LastPutAwayBanner = ({ item }: Props) => {
    const { t } = useTranslation();
    if (!item) return null;

    return (
        <div key={item.sku} className="pa-lastpick" role="status">
            <ProductImage thumbnailUrl={item.thumbnailUrl} imageUrl={item.imageUrl} />
            <div className="pa-lastpick-body">
                <div className="pa-lastpick-eyebrow">{t("put_away_last_put_away")}</div>
                {item.title && <div className="pa-lastpick-title">{item.title}</div>}
                <div className="pa-lastpick-barcode">{groupBarcode(item.barcode || item.sku)}</div>
            </div>
        </div>
    );
};

export default LastPutAwayBanner;
